module.exports = __webpack_public_path__ + "img/contrast_png.62e847cf.png";